import { urlBehindTheSeizure } from "./constants";

export const analyticsCategories = {
  geneticMolecularTesting: 'Genetic / Molecular testing',
  enzymeActivityAnalysis: 'Enzyme Activity Analysis',
  inclusionCriteria: 'Inclusion Criteria' , 
}

function getFeatureAnalyticsCategory(elementId) {
  switch (true) {
    case elementId.includes('molecularTesting'):
      return analyticsCategories.geneticMolecularTesting;
    case elementId.includes('enzymeAnalysis'):
      return analyticsCategories.enzymeActivityAnalysis;
    case elementId.includes('inclusionCriteria'):
      return analyticsCategories.inclusionCriteria;
    default:
      return '';
  }
}

export function dispatchAnalytics_onClickPopupYes_US() {
  dataLayer.push({
    'event' : 'Popup',
    'eventCategory' : 'Pop-up HCP Selection',
    'eventAction' : 'Click-Yes',
    'eventLabel' : urlBehindTheSeizure // Dynamically populate the URL of the link
  }); 
}

export function dispatchAnalytics_onClickPopupYes_notUS() {
  dataLayer.push({
    'event' : 'Popup',
    'eventCategory' : 'Pop-up HCP Selection',
    'eventAction' : 'Click-Yes',
    'eventLabel' : `${hcpData.root_url}/en-uk/cln2-main` // TODO check behavior
    });
}

export function dispatchAnalytics_countrySelection(countryCode, countryName) {
  dataLayer.push({
    'event': 'CountrySelection',
    'eventCategory': 'Country Selection',
    'eventAction': countryName, // This should be dynamically populated for Selected Country
    'eventLabel': `${hcpData.root_url}/en-uk/cln2-lab-listing?country=${countryCode}` // Dynamically populate the URL of the link
  });
};

export function dispatchAnalytics_disclaimerAgree(selectedCountryCode) {
  dataLayer.push({
    'event' : 'Popup',
    'eventCategory' : 'Disclaimer Pop-up',
    'eventAction' : 'Click-I Agree',
    'eventLabel' : `${hcpData.root_url}/en-uk/cln2-lab-listing?country=${selectedCountryCode}` // Dynamically populate the URL of the link 
    });
};

export function dispatchAnalytics_labFeaturePopupMobile(event) {
  const popup = event.currentTarget.querySelector('.popuptext');
  const category = getFeatureAnalyticsCategory(event.currentTarget.id);
  // Only dispatch event when popup becomes visible
  if (popup.classList.contains('show')) {
    dataLayer.push({
      'event' : 'LabDetails',
      'eventCategory' : 'Lab Details',
      'eventAction' : `Click-${category}`, // TODO change to include type
      'eventLabel' : event.currentTarget.id
    });
  }
};

export function dispatchAnalytics_labFeaturePopupHover(event) {
  const category = getFeatureAnalyticsCategory(event.currentTarget.id);
    dataLayer.push({
      'event' : 'MouseHover',
      'eventCategory' : 'Mouse Hover',
      'eventAction' : `Mouse Hover-${category}`,
      'eventLabel' : event.currentTarget.id // TODO Check value (event.currentTarget.id?)
    });
};

export function dispatchAnalytics_CTA_stayInformed() {
    dataLayer.push({
      'event' : 'RegisterForm',
      'eventCategory' : 'Register Form',
      'eventAction': 'Click-Stay Informed',
      'eventLabel' : 'https:\/\/www.cln2connection.com/register/' // Dynamically populate the URL of the link
    });
};

export function dispatchAnalytics_CTA_visitSite() {
    dataLayer.push({
      'event': 'InternalLinkClick',
      'eventCategory' : 'Internal Link Click',
      'eventAction': 'Click-Visit CLN2 Disease Website',
      'eventLabel' : 'https:\/\/www.cln2connection.com/' // Dynamically populate the URL of the link
    });
};